import React from 'react';

type ImageData = {
  src: string;
  title: string;
  place: string;
  text: string;
  sizeClass?: string; // 画像の横幅などを指定するクラス（例: "w-[480px] h-[679px]"）
  heightClass?: string; // 画像の高さを指定するクラス（例: "h-[300px]"）
};

type ThreeImagesProps = {
  images: ImageData[];
};

const ThreeImages: React.FC<ThreeImagesProps> = ({ images }) => {
  return (
    <div className="flex justify-center gap-x-3">
      {images.map((image, index) => (
        <div
          key={index}
          className={`flex flex-col flex-none ${index === 2 ? 'mt-[400px]' : ''}`}
        >
          <figure className="flex flex-col">
            <img
              src={image.src}
              alt={image.title}
              className={`object-cover ${image.sizeClass ?? ''} ${image.heightClass ?? ''}`}
            />
            <figcaption className="text-[10px] text-start">
              {image.title}
            </figcaption>
          </figure>
        </div>
      ))}
    </div>
  );
};

export default ThreeImages;
